module.exports = __webpack_public_path__ + "img/tjdj_banner.2781fbb7.png";